
import { ChangeDetectionStrategy, Component, effect, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { FikoYTKokBilesenComponent } from '../../../service/kok-bilesen/kok-bilesen.component';
import { PaylasKutusuComponent } from '@/src/service/fikoyt-ui/src/lib/paylasim-sistemi/paylas-kutusu/paylas-kutusu.component';
import { FikoYTKartKokComponent } from '@/src/service/fikoyt-ui/src/lib/paylasim-sistemi/fikoyt-kart-kok/fikoyt-kart.component';
import { ServisUyarProjeler } from '../uyar-dokum/projeler/projeler.service';
import { HmiYonetimService } from '../hmi-pano/pano/pages/personel/pages/yonetim-kayit/hmi-yonetim.service';
import { HmiSatisService } from '../hmi-pano/pano/pages/personel/pages/satis/hmi-satis.service';
import { HmiUretimService } from '../hmi-pano/pano/pages/personel/pages/uretim/hmi-uretim.service';
import { HmiProjelerService } from '../hmi-pano/pano/pages/personel/pages/projeler/hmi-projeler.service';
import { FikoYTIstekSayfalama, ISayfalama } from '@/src/service/modules/fikoyt-istek-kok/fikoyt-istek-sayfalama';
import { IVT, IYollar } from '@/src/service/fikoyt-ui/interfaces/IKart.interface';
import { IParametreSetiGrubu } from '@/src/service/fikoyt-ui/interfaces/IParametreSeti.interface';
import { NzPaginationModule } from 'ng-zorro-antd/pagination';
import { NzGridModule } from 'ng-zorro-antd/grid';
import { NzButtonModule } from 'ng-zorro-antd/button';
import { NzCheckboxModule } from 'ng-zorro-antd/checkbox';
import { BildirimDropdownComponent } from '@/src/app/shared/components/bildirim-dropdown/bildirim-dropdown.component';
import { NzPopconfirmModule } from 'ng-zorro-antd/popconfirm';
import { NzMessageService } from 'ng-zorro-antd/message';
import { FikoYTUygBaslikComponent } from '@/src/service/fikoyt-ui/src/lib/fikoyt-uygulama-baslik/fikoyt-uygulama-baslik.component';
import { IKart, IKartTuru } from '@/src/service/fikoyt-ui/interfaces/IKart.interface';
import { FikoYTIstekKok } from '@/src/service/modules/fikoyt-istek-kok/fikoyt.istek.makinesi.service';
import { FikoFilitreciComponent } from '@/src/service/fikoyt-ui/src/lib/fiko-filitreci/fiko-filitreci.component';
import { IGrupI } from '@/src/service/fikoyt-ui/interfaces/IGrup';
import { CanliGuncellemeService } from '@/src/service/fikoyt-ui/src/lib/dinamik-bilesen/canli-guncelleme.service';
import { parametredenSiralamaOlustur, IDinamikBilesenFiltreSet } from '@/src/service/fikoyt-ui/src/lib/fiko-filitreci/parametre-filitre-yardimci';
import { SISTEM_PARAMETRE_SETLERI } from '@/src/service/fikoyt-ui/src/lib/parametre-setleri/sistem-parametre-setleri';

@Component({
  selector: 'fikoyt-paylasim-sistemi',
  templateUrl: './paylasim-sistemi.component.html',
  styleUrls: ['./paylasim-sistemi.component.less'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    CommonModule,
    FormsModule,
    RouterModule,
    PaylasKutusuComponent,
    FikoYTKartKokComponent,
    NzPaginationModule,
    NzGridModule,
    NzButtonModule,
    NzCheckboxModule,
    BildirimDropdownComponent,
    NzPopconfirmModule,
    FikoYTUygBaslikComponent,
    FikoFilitreciComponent,
  ]
})
export class PaylasimSistemiComponent extends FikoYTKokBilesenComponent {
  /** Kullanıcı filtresinin pipeline'daki sabit konumu (son aşama — lookup/addFields/project sonrası) */
  private static readonly FILTRE_ASAMASI = 10;
  listeIstek: FikoYTIstekSayfalama;
  u_id: string | null = null;
  ustKart: IKart | null = null;
  altKartSablonlari: any[] = [];
  tumParametreSetleri: IParametreSetiGrubu[] = [];
  private canliGuncelleme = inject(CanliGuncellemeService);
  private hmiYonetim = inject(HmiYonetimService);
  private hmiSatis = inject(HmiSatisService);
  private hmiUretim = inject(HmiUretimService);
  private hmiProjeler = inject(HmiProjelerService);

  constructor(public servisProjeler: ServisUyarProjeler) {
    super();
    //@ts-ignore
    this.listeIstek = new FikoYTIstekSayfalama({
      metod: 'POST',
      komut: 'FikoYT.sistem.DB.hareketler.aggregate',
      onEkOlsun: true,
      filitreler: [
        { $match: { vt: "FikoYT.sistem.hareketler" as IVT, yol: "FikoYT.sistem.hareketler.kalem" as IYollar } },
        { $match: { silindi: { $ne: true } } },
        {
          $lookup: {
            from: "hareketler",
            localField: "veri.icerikler",
            foreignField: "_id",
            as: "veri.icerikler"
          }
        },
        // 🚀 PERFORMANS: yorumSayisi/_hesap.* artık her sayfa yüklemesinde 4 ayrı
        // iç-içe $lookup ile CANLI hesaplanmıyor — bir alt kart eklendiğinde/
        // güncellendiğinde AltKartOzetService tarafından karta yazılıp önbelleklenen
        // değerler doğrudan okunuyor (bkz. ikart-kutusu.component.ts paylasTiklandi).
        // Henüz özeti hesaplanmamış eski kartlar için $ifNull ile 0/null'a düşer.
        {
          $addFields: {
            yorumSayisi: { $ifNull: ['$yorumSayisi', 0] },
            '_hesap.altKartSayisi': { $ifNull: ['$_hesap.altKartSayisi', 0] },
            '_hesap.sonDurum': { $ifNull: ['$_hesap.sonDurum', null] },
            '_hesap.projeSonDurum': { $ifNull: ['$_hesap.projeSonDurum', null] },
            '_hesap.projeIlerleme': { $ifNull: ['$_hesap.projeIlerleme', 0] },
            '_hesap.projeAltToplam': { $ifNull: ['$_hesap.projeAltToplam', 0] },
            '_hesap.projeAltTamamlanan': { $ifNull: ['$_hesap.projeAltTamamlanan', 0] },
            // Cam kütük ölçüleri: kartın KENDİ veri.icerikler[0]'ından türetiliyor (ekstra
            // $lookup gerektirmez, zaten yukarıda join edilmiş veri üzerinde çalışır — ucuz).
            '_hesap.olculer': {
              $let: {
                vars: { ic: { $arrayElemAt: ['$veri.icerikler', 0] } },
                in: {
                  $sortArray: {
                    input: {
                      $filter: {
                        input: [
                          { $convert: { input: '$$ic.ek.en', to: 'double', onError: null, onNull: null } },
                          { $convert: { input: '$$ic.ek.boy', to: 'double', onError: null, onNull: null } },
                          { $convert: { input: '$$ic.ek.yukseklik', to: 'double', onError: null, onNull: null } }
                        ],
                        as: 'v',
                        cond: { $and: [{ $ne: ['$$v', null] }, { $gt: ['$$v', 0] }] }
                      }
                    },
                    sortBy: 1
                  }
                }
              }
            }
          }
        },
        {
          $addFields: {
            '_hesap.enKucukOlcu': { $arrayElemAt: ['$_hesap.olculer', 0] },
            '_hesap.ortancaOlcu': { $arrayElemAt: ['$_hesap.olculer', 1] },
            '_hesap.enBuyukOlcu': { $arrayElemAt: ['$_hesap.olculer', 2] },
          }
        },
        // 🚀 PERFORMANS: yeFikolaSayisi (repost) artık feed'de TEK $lookup ile
        // toplu hesaplanıyor — eskiden her kart kendi effect'inde ayrı aggregate
        // atıyordu (10 kart = 10 istek = N+1). Mantık yeFikolaSayisiniGuncelle
        // ile birebir aynı; bkz. fikoyt-kart.component.ts fallback effect'i.
        {
          $lookup: {
            from: "hareketler",
            let: { kid: "$_id" },
            pipeline: [
              { $match: { $expr: { $and: [
                  { $eq: ["$ek.turu", "REFERANS"] },
                  { $eq: ["$ek.rid", "$$kid"] }
                ] },
                _uid: { $exists: true },
                silindi: { $ne: true } } },
              { $lookup: { from: "hareketler", localField: "_uid", foreignField: "_id", as: "_ust" } },
              { $unwind: "$_ust" },
              { $match: { "_ust.silindi": { $ne: true } } },
              { $count: "toplam" }
            ],
            as: "_yeFikolaSayim"
          }
        },
        {
          $addFields: {
            yeFikolaSayisi: { $ifNull: [{ $arrayElemAt: ["$_yeFikolaSayim.toplam", 0] }, 0] }
          }
        },
        // Kullanıcı filtresi — daima pipeline sonunda (bkz. FILTRE_ASAMASI)
        { $match: {} },
      ],
      sayfalama: {
        sayi: 10,
        siralama: { _id: -1 }
      } as ISayfalama,
      depoModu: false,
      oncelik: 0,
      gecikmeliCevap: false,
      gecikmeliCevapSuresi: 0,
      otoSonId: true,
      eklemeliListe: false,
    })
      .onMesgulDegisti(({ self, mesgul }) => {
        // setTimeout(() => {
          this.CD.detectChanges();
        // });
      })
      .onHata(({ self, hatalar }) => {
        this.nzNotification.error("Hatalar Var", hatalar.map(hata => hata.mesaj).join("\n"));
      }).onTamamlandi(({ self }) => {
        // setTimeout(() => {
          this.CD.detectChanges();
        // });
      });

    delete (this.servisProjeler.kart as any).kisiId;

    const hmiGrubu = SISTEM_PARAMETRE_SETLERI.find(g => g.id === 'sistem.hmi');
    const kutukStokGrubu = SISTEM_PARAMETRE_SETLERI.find(g => g.id === 'sistem.kutuk-stok');
    const genelStokGrubu = SISTEM_PARAMETRE_SETLERI.find(g => g.id === 'sistem.genel-stok');
    // const camIslemeGrubu = SISTEM_PARAMETRE_SETLERI.find(g => g.id === 'sistem.cam-isleme');
    this.tumParametreSetleri = [
      // ...(this.hmiProjeler.parametreSetleri || []),
      // ...(this.hmiYonetim.parametreSetleri || []),
      // ...(this.hmiSatis.parametreSetleri || []),
      // ...(this.hmiUretim.parametreSetleri || []),
      ...(hmiGrubu ? [hmiGrubu] : []),
      ...(kutukStokGrubu ? [kutukStokGrubu] : []),
      ...(genelStokGrubu ? [genelStokGrubu] : []),
      // ...(camIslemeGrubu ? [camIslemeGrubu] : []),
      {
        id: 'uyar.model',
        baslik: 'Uyar Model',
        simge: '🎯',
        kaynak: 'kod',
        altGruplar: [
          { id: 'cam-kutuk', baslik: 'Kütük', simge: '🪵', bilesen: 'cam-kutuk', kaynak: 'kod',
            parametreler: [
              { turu: 'Yazı', ismi: 'kutukId', baslik: 'Kütük ID' },
              { turu: 'Yazı', ismi: 'projeAdi', baslik: 'Proje Adı' },
              { turu: 'Sayı', ismi: 'en', baslik: 'En (mm)', ayarlar: { min: 0 } },
              { turu: 'Sayı', ismi: 'boy', baslik: 'Boy (mm)', ayarlar: { min: 0 } },
              { turu: 'Sayı', ismi: 'yukseklik', baslik: 'Yükseklik (mm)', ayarlar: { min: 0 } },
              { turu: 'Sayı', ismi: 'adet', baslik: 'Adet', ayarlar: { min: 1 } },
              { turu: 'Yazı Alanı', ismi: 'notlar', baslik: 'Notlar' },
            ],
            hesapAlanlari: [
              {
                ismi: '_hesap.sonDurum', baslik: 'Son Durum', simge: '🔄',
                tipi: 'secim', coklu: true,
                secenekler: [
                  { etiket: '⏳ Bekliyor', deger: 'Bekliyor' },
                  { etiket: '👁️ Görüldü', deger: 'Görüldü' },
                  { etiket: '🔨 Hazırlanıyor', deger: 'Hazırlanıyor' },
                  { etiket: '✅ Tamamlandı', deger: 'Tamamlandı' },
                  { etiket: '❌ İptal', deger: 'İptal' },
                ],
              },
              {
                ismi: '_hesap.olculer.tek', alanYolu: '_hesap.olculer',
                baslik: 'Herhangi Bir Ölçü (mm)', simge: '📏',
                tipi: 'sayı',
              },
              {
                ismi: '_hesap.olculer.tam', alanYolu: '_hesap.olculer',
                baslik: 'Tam Ölçü Eşleşmesi (X×Y×Z sırasız)', simge: '📐',
                tipi: 'olcu-uclu',
              },
              {
                ismi: '_hesap.olculer.sinir', alanYolu: '_hesap.olculer',
                baslik: 'Ölçü Sınırları (min/max — sıralı)', simge: '📊',
                tipi: 'olcu-sinir',
              },
              {
                ismi: '_hesap.enKucukOlcu',
                baslik: 'En Küçük Ölçü', simge: '🔻',
                tipi: 'sayı',
              },
              {
                ismi: '_hesap.ortancaOlcu',
                baslik: 'Ortanca Ölçü', simge: '🟰',
                tipi: 'sayı',
              },
              {
                ismi: '_hesap.enBuyukOlcu',
                baslik: 'En Büyük Ölçü', simge: '🔺',
                tipi: 'sayı',
              },
            ],
            altKartSablonlari: [
              { id: 'cam.kutuk.durum', baslik: 'Durum Güncelleme', simge: '🔄', bilesen: 'cam-kutuk-durum', parametreler: [
                { turu: 'Açılır Kutu', ismi: 'durum', baslik: 'Durum', ayarlar: { zorunlu: true, secenekler: [
                  { label: 'Bekliyor', value: 'Bekliyor' }, { label: 'Görüldü', value: 'Görüldü' },
                  { label: 'Hazırlanıyor', value: 'Hazırlanıyor' }, { label: 'Tamamlandı', value: 'Tamamlandı' },
                  { label: 'İptal', value: 'İptal' },
                ] } },
                { turu: 'Yazı Alanı', ismi: 'notlar', baslik: 'Notlar' },
              ] },
            ],
          } as any,
          { id: 'proje-tanimi', baslik: 'Proje Tanımı', simge: '📂', bilesen: 'proje-tanimi', kaynak: 'kod',
            parametreler: [
              { turu: 'Yazı', ismi: 'projeAdi', baslik: 'Proje Adı', ayarlar: { zorunlu: true } },
              { turu: 'Yazı', ismi: 'projeKodu', baslik: 'Proje Kodu' },
              { turu: 'Yazı', ismi: 'musteri', baslik: 'Müşteri' },
              { turu: 'Açılır Kutu', ismi: 'kategori', baslik: 'Kategori', ayarlar: { secenekler: [
                { etiket: 'Üretim', deger: 'Üretim' },
                { etiket: 'AR-GE', deger: 'AR-GE' },
                { etiket: 'Bakım', deger: 'Bakım' },
                { etiket: 'Tasarım', deger: 'Tasarım' },
                { etiket: 'Diğer', deger: 'Diğer' },
              ] } },
              { turu: 'Açılır Kutu', ismi: 'oncelik', baslik: 'Öncelik', ayarlar: { secenekler: [
                { etiket: 'Düşük', deger: 'Düşük' },
                { etiket: 'Normal', deger: 'Normal' },
                { etiket: 'Yüksek', deger: 'Yüksek' },
                { etiket: 'Kritik', deger: 'Kritik' },
              ] } },
              { turu: 'Tarih', ismi: 'baslangicTarihi', baslik: 'Başlangıç Tarihi' },
              { turu: 'Tarih', ismi: 'hedefBitis', baslik: 'Hedef Bitiş' },
              { turu: 'Yazı', ismi: 'sorumlu', baslik: 'Sorumlu' },
              { turu: 'Yazı Alanı', ismi: 'aciklama', baslik: 'Açıklama' },
            ],
            hesapAlanlari: [
              {
                ismi: '_hesap.projeSonDurum', baslik: 'Son Durum', simge: '🔄',
                tipi: 'secim', coklu: true,
                secenekler: [
                  { etiket: '⏳ Planlandı', deger: 'Planlandı' },
                  { etiket: '🚀 Devam Ediyor', deger: 'Devam Ediyor' },
                  { etiket: '⏸️ Beklemede', deger: 'Beklemede' },
                  { etiket: '✅ Tamamlandı', deger: 'Tamamlandı' },
                  { etiket: '❌ İptal', deger: 'İptal' },
                ],
              },
              { ismi: '_hesap.projeIlerleme', baslik: 'İlerleme %', simge: '📊', tipi: 'sayı' },
              { ismi: '_hesap.projeAltToplam', baslik: 'Görev Sayısı', simge: '🗂️', tipi: 'sayı' },
              { ismi: '_hesap.projeAltTamamlanan', baslik: 'Tamamlanan Görev', simge: '✅', tipi: 'sayı' },
            ],
            altKartSablonlari: [
              { id: 'proje.tanimi.durum', baslik: 'Durum Güncelleme', simge: '🔄', bilesen: 'proje-tanimi-durum', parametreler: [
                { turu: 'Açılır Kutu', ismi: 'durum', baslik: 'Durum', ayarlar: { zorunlu: true, secenekler: [
                  { etiket: 'Planlandı', deger: 'Planlandı' },
                  { etiket: 'Devam Ediyor', deger: 'Devam Ediyor' },
                  { etiket: 'Beklemede', deger: 'Beklemede' },
                  { etiket: 'Tamamlandı', deger: 'Tamamlandı' },
                  { etiket: 'İptal', deger: 'İptal' },
                ] } },
                { turu: 'Açılır Kutu', ismi: 'ilerlemeTipi', baslik: 'İlerleme Tipi', ayarlar: { secenekler: [
                  { etiket: '🎯 Kesin (Tam Durum)', deger: 'kesin' },
                  { etiket: '➕ Eklemeli (+)', deger: 'eklemeli' },
                ] } },
                { turu: 'Sayı', ismi: 'ilerlemeDegeri', baslik: 'İlerleme %', ayarlar: { min: 0, maks: 100 } },
                { turu: 'Yazı Alanı', ismi: 'notlar', baslik: 'Notlar' },
              ] },
            ],
          } as any,
        ],
      } as any,
    ];

    this.route.paramMap.subscribe(params => {
      this.u_id = params.get('u_id');
      if (this.u_id) {
        (this.servisProjeler.kart as any)._uid = this.u_id;
        this.ustKartYukle(this.u_id);
      } else {
        delete (this.servisProjeler.kart as any)._uid;
      }
      this.filtreGuncelle();
      setTimeout(() => {
        this.listeIstek.isteSync();
      });
    });

    effect(() => {
      const g = this.canliGuncelleme.kartGuncellendi();
      if (!g) return;
      const idx = this.listeIstek.liste.findIndex(k => k._id === g.kartId);
      if (idx >= 0) { this.listeIstek.liste[idx] = { ...this.listeIstek.liste[idx], ...g.veri }; this.listeIstek.liste = this.listeIstek.liste.slice(); this.CD.detectChanges(); }
    });
    effect(() => {
      const id = this.canliGuncelleme.kartSilindi();
      if (!id) return;
      const onceki = this.listeIstek.liste.length;
      this.listeIstek.liste = this.listeIstek.liste.filter(k => k._id !== id);
      if (this.listeIstek.liste.length < onceki && this.listeIstek.sayfalama.toplamKayitSayisi > 0) {
        this.listeIstek.sayfalama.toplamKayitSayisi--;
      }
      this.CD.detectChanges();
    });
    effect(() => {
      const kart = this.canliGuncelleme.kartYeni();
      if (!kart) return;
      if (this.listeIstek.liste.some(k => k._id === kart._id)) return;
      this.listeIstek.liste = [kart, ...this.listeIstek.liste];
      this.listeIstek.sayfalama.toplamKayitSayisi++;
      this.CD.detectChanges();
    });

    // Sunucudan (Socket.IO) gelen kart olayları — diğer kullanıcı/cihazlar
    this.canliGuncelleme.socketBagla(this.FikoYT.io);
    effect(() => {
      const olay = this.canliGuncelleme.sunucuOlayi();
      if (!olay) return;
      switch (olay.tip) {
        case 'silindi':
          this.canliGuncelleme.kartSilindi.set(olay.kartId);
          break;
        case 'guncellendi':
          this.tekKartYenile(olay.kartId);
          break;
        case 'yeni':
          this.listeYenileGecikmeli();
          break;
      }
    });
  }

  /** Yeni kart olaylarında listeyi tek seferde yeniler (art arda olayları toplar) */
  private listeYenileZamanlayici: any = null;
  private listeYenileGecikmeli() {
    if (this.listeYenileZamanlayici) clearTimeout(this.listeYenileZamanlayici);
    this.listeYenileZamanlayici = setTimeout(() => {
      this.listeYenileZamanlayici = null;
      this.listeIstek.isteSync();
    }, 600);
  }

  /** Tek kartı (içerik lookup'lı) sunucudan çekip listede yerine koyar */
  private async tekKartYenile(kartId: string) {
    if (!this.listeIstek.liste.some((k: any) => k._id === kartId) && this.ustKart?._id !== kartId) {
      // Kart henüz listede değil (yeni geldi / yenileme sürüyor) — listeyi topluca yenile
      this.listeYenileGecikmeli();
      return;
    }
    try {
      const istek = new FikoYTIstekKok({
        metod: 'POST',
        komut: 'FikoYT.sistem.DB.hareketler.aggregate',
        parametreler: {
          aggregate: [
            { $match: { _id: kartId } },
            { $lookup: { from: 'hareketler', localField: 'veri.icerikler', foreignField: '_id', as: 'veri.icerikler' } },
            { $limit: 1 }
          ]
        }
      });
      const cevap: any = await istek.isteSync();
      const kart = cevap?.cevap?.sonuc?.[0];
      if (!kart) return;
      if (kart.silindi) {
        this.canliGuncelleme.kartSilindi.set(kartId);
        return;
      }
      if (this.ustKart?._id === kartId) {
        this.ustKart = kart;
        this.CD.detectChanges();
        return;
      }
      this.kartYerineKoy(kart);
    } catch { /* sessiz — sonraki olay/yenileme telafi eder */ }
  }

  async ustKartYukle(kartId: string) {
    try {
      const istek = new FikoYTIstekKok({
        metod: 'POST',
        komut: 'FikoYT.sistem.DB.hareketler.aggregate',
        parametreler: {
          aggregate: [
            { $match: { _id: kartId, silindi: { $ne: true } } },
            { $lookup: { from: 'hareketler', localField: 'veri.icerikler', foreignField: '_id', as: 'veri.icerikler' } },
            { $limit: 1 }
          ]
        }
      });
      const cevap: any = await istek.isteSync();
      const kart = cevap?.cevap?.sonuc?.[0];
      if (!kart) return;
      this.ustKart = kart;
      const setIdleri = new Set<string>();
      kart.veri?.icerikler?.forEach((ic: any) => {
        if (ic?.ek?._secilenSetId) setIdleri.add(ic.ek._secilenSetId);
        if (ic?.ek?.bilesen) setIdleri.add(ic.ek.bilesen);
      });
      const tumSetler = [
        ...this.tumParametreSetleri,
      ];
      const sablonlar: any[] = [];
      const bul = (gruplar: any[]) => {
        for (const g of gruplar) {
          const eslesme = setIdleri.has(g.id) || setIdleri.has(g.bilesen) || (g.bilesen && setIdleri.has(g.bilesen));
          if (eslesme && g.altKartSablonlari?.length) sablonlar.push(...g.altKartSablonlari);
          if (!eslesme && g.altGruplar?.length) bul(g.altGruplar);
          if (eslesme && g.altGruplar?.length) {
            for (const alt of g.altGruplar) {
              if (alt.altKartSablonlari?.length) sablonlar.push(...alt.altKartSablonlari);
            }
          }
        }
      };
      bul(tumSetler);
      this.altKartSablonlari = sablonlar.length ? [{ id: 'alt-sablonlar', baslik: 'Alt Kart Şablonları', simge: '📋', kaynak: 'kod', altGruplar: sablonlar }] : [];
      this.CD.detectChanges();
    } catch (e) {
      this.nzMessage.error('Üst kart yüklenemedi');
    }
  }

  filtreGuncelle() {
    if (this.u_id) {
      this.listeIstek.filitreler[0] = { $match: { vt: "FikoYT.sistem.hareketler" as IVT, _uid: this.u_id, turu: { $in: [IKartTuru.KART, IKartTuru.UYAR_DOKUM] }, silindi: { $ne: true } } };
    } else {
      this.listeIstek.filitreler[0] = { $match: { vt: "FikoYT.sistem.hareketler" as IVT, yol: "FikoYT.sistem.hareketler.kalem" as IYollar, $or: [{ u_id: { $exists: false } }, { u_id: null }], _uid: { $exists: false } } };
    }
    this.listeIstek.parametreler.aggregate = this.listeIstek._alAggregate();
  }

  // --- Filtre ---
  filitreciAcik = false;
  filitreciSablon: IGrupI = { veVeya: "ve", acik: false, alanlar: [] };

  temelSiralamalar = [
    { ismi: '📅 En Yeni', degeri: { tarih: -1 } },
    { ismi: '📅 En Eski', degeri: { tarih: 1 } },
    { ismi: '✏️ Son Düzenlenen', degeri: { duzenlenmeTarihi: -1 } },
    { ismi: '✏️ İlk Düzenlenen', degeri: { duzenlenmeTarihi: 1 } },
  ];
  aktifSiralama: any = { tarih: -1 };

  get siralamalar() {
    return [...this.temelSiralamalar, ...parametredenSiralamaOlustur(this.tumParametreler)];
  }

  siralamaDegisti(deger: any) {
    this.aktifSiralama = deger;
    this.listeIstek.sayfalama.siralama = deger;
    this.listeIstek.sayfalama.sayfa = 1;
    this.listeIstek.parametreler.aggregate = this.listeIstek._alAggregate();
    this.listeIstek.isteSync();
  }

  get bilesenTipleri() {
    const sonuc: any[] = [];
    const gorulenler = new Set<string>();
    const tara = (gruplar: any[]) => {
      for (const g of gruplar) {
        if (g.bilesen && !gorulenler.has(g.bilesen)) {
          gorulenler.add(g.bilesen);
          sonuc.push({ id: g.bilesen, baslik: g.baslik, renk: g.renk, simge: g.simge });
        }
        if (g.altGruplar?.length) tara(g.altGruplar);
        if (g.altKartSablonlari?.length) tara(g.altKartSablonlari);
      }
    };
    tara(this.tumParametreSetleri || []);
    return sonuc;
  }

  get tumParametreler() {
    const sonuc: any[] = [];
    const gorulenler = new Set<string>();
    const tara = (gruplar: any[]) => {
      for (const g of gruplar) {
        for (const p of (g.parametreler || [])) {
          if (!gorulenler.has(p.ismi)) { gorulenler.add(p.ismi); sonuc.push(p); }
        }
        if (g.altGruplar?.length) tara(g.altGruplar);
        if (g.altKartSablonlari?.length) tara(g.altKartSablonlari);
      }
    };
    tara(this.tumParametreSetleri || []);

    return sonuc;
  }


  get dinamikBilesenSetleri(): IDinamikBilesenFiltreSet[] {
    const sonuc: IDinamikBilesenFiltreSet[] = [];
    const gorulenler = new Set<string>();
    const tara = (gruplar: any[]) => {
      for (const g of gruplar) {
        if (g.bilesen && !gorulenler.has(g.bilesen)) {
          gorulenler.add(g.bilesen);
          const parametreler = [...(g.parametreler || []), ...(g.altGruplar?.flatMap((ag: any) => ag.parametreler || []) || [])];
          const hesapAlanlari = g.hesapAlanlari || [];
          if (parametreler.length > 0 || hesapAlanlari.length > 0) {
            sonuc.push({ id: g.bilesen, setId: g.id, baslik: g.baslik, simge: g.simge, parametreler, hesapAlanlari });
          }
        }
        if (g.altGruplar?.length) tara(g.altGruplar);
        if (g.altKartSablonlari?.length) tara(g.altKartSablonlari);
      }
    };
    tara(this.tumParametreSetleri || []);
    tara(SISTEM_PARAMETRE_SETLERI);
    return sonuc;
  }

  filitreciAcKapa() {
    this.filitreciAcik = !this.filitreciAcik;
    this.CD.detectChanges();
  }

  filtreUygula() {
    const mongoSorgu = FikoFilitreciComponent.toMongoFromSablon(this.filitreciSablon) || {};
    const match = (mongoSorgu && Object.keys(mongoSorgu).length) ? mongoSorgu : {};
    this.listeIstek.filitreler[PaylasimSistemiComponent.FILTRE_ASAMASI] = { $match: match };
    this.listeIstek.sayfalama.sayfa = 1;
    this.listeIstek.parametreler.aggregate = this.listeIstek._alAggregate();
    this.listeIstek.isteSync();
  }

  filtreTemizle() {
    this.filitreciSablon = { veVeya: "ve", acik: true, alanlar: [] };
    this.listeIstek.filitreler[PaylasimSistemiComponent.FILTRE_ASAMASI] = { $match: {} };
    this.listeIstek.sayfalama.sayfa = 1;
    this.listeIstek.parametreler.aggregate = this.listeIstek._alAggregate();
    this.listeIstek.isteSync();
    this.CD.detectChanges();
  }

  /** Güncellenen kartı _id eşleşmesiyle listeye yerleştirir ($index kaymalarına dayanıklı) */
  kartYerineKoy(guncel: IKart) {
    const idx = this.listeIstek.liste.findIndex((k: any) => k._id === (guncel as any)._id);
    if (idx < 0) return;
    this.listeIstek.liste[idx] = guncel;
    this.listeIstek.liste = this.listeIstek.liste.slice();
    this.CD.detectChanges();
  }

  // --- Toplu İşlem Modu ---
  topluIslemModu = false;
  seciliKartIdler = new Set<string>();
  topluIslemMesgul = false;

  topluIslemModuAcKapa() {
    this.topluIslemModu = !this.topluIslemModu;
    if (!this.topluIslemModu) {
      this.seciliKartIdler.clear();
    }
    this.CD.detectChanges();
  }

  kartSeciliMi(kartId: string): boolean {
    return this.seciliKartIdler.has(kartId);
  }

  kartSecimDegistir(kartId: string, secili: boolean) {
    if (secili) {
      this.seciliKartIdler.add(kartId);
    } else {
      this.seciliKartIdler.delete(kartId);
    }
    this.CD.detectChanges();
  }

  tumunuSec() {
    if (this.seciliKartIdler.size === this.listeIstek.liste.length) {
      this.seciliKartIdler.clear();
    } else {
      for (const k of this.listeIstek.liste) {
        this.seciliKartIdler.add(k._id);
      }
    }
    this.CD.detectChanges();
  }

  get seciliSayi(): number {
    return this.seciliKartIdler.size;
  }

  /** Toplu işlemleri sınırlı eşzamanlılıkla (5) paralel yürütür */
  private async topluYurut(govdeler: any[]): Promise<number> {
    let basarili = 0;
    const ESZAMANLI = 5;
    for (let i = 0; i < govdeler.length; i += ESZAMANLI) {
      const grup = govdeler.slice(i, i + ESZAMANLI).map(async (govde) => {
        const formData = new FormData();
        formData.append('req_body', JSON.stringify(govde));
        const istek = new FikoYTIstekKok({
          metod: 'POST',
          komut: 'FikoYT.sistem.DB.hareketler.ekle',
          parametreler: formData,
          onEkOlsun: true,
          depoModu: false,
        });
        await istek.isteSync();
      });
      const sonuclar = await Promise.allSettled(grup);
      basarili += sonuclar.filter(s => s.status === 'fulfilled').length;
    }
    return basarili;
  }

  async topluSil() {
    if (this.seciliSayi === 0) return;
    this.topluIslemMesgul = true;
    this.CD.detectChanges();

    const govdeler = [...this.seciliKartIdler].map(kartId => ({ _id: kartId, silindi: true }));
    const basarili = await this.topluYurut(govdeler);

    if (basarili < govdeler.length) this.nzMessage.error(`${govdeler.length - basarili} kart silinemedi`);
    this.nzMessage.success(`${basarili} kart silindi`);
    this.seciliKartIdler.clear();
    this.topluIslemMesgul = false;
    this.listeIstek.isteSync();
    this.CD.detectChanges();
  }

  async topluEtiketle(etiket: string) {
    if (this.seciliSayi === 0 || !etiket) return;
    this.topluIslemMesgul = true;
    this.CD.detectChanges();

    const govdeler = [...this.seciliKartIdler].map(kartId => {
      const kart = this.listeIstek.liste.find((k: any) => k._id === kartId);
      const mevcutEtiketler = kart?.etiketler ?? [];
      if (!mevcutEtiketler.includes(etiket)) mevcutEtiketler.push(etiket);
      return { _id: kartId, etiketler: mevcutEtiketler };
    });
    const basarili = await this.topluYurut(govdeler);

    if (basarili < govdeler.length) this.nzMessage.error(`${govdeler.length - basarili} kart etiketlenemedi`);
    this.nzMessage.success(`${basarili} kart etiketlendi: ${etiket}`);
    this.topluIslemMesgul = false;
    this.listeIstek.isteSync();
    this.CD.detectChanges();
  }

  override ngOnDestroy() {
    super.ngOnDestroy();
  }

  override async ngAfterViewInit() {
    super.ngAfterViewInit();
  }
}
